import { Button, Divider, Grid, Typography } from '@mui/material'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import PrimeTable from '../../../components/PrimeTable'
import { useState, useContext } from 'react'
import { metodoPrograma } from '../../../components/api'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import { PropostaContext } from './index'

const DivisaoEmpresaNF = () => {
  const { dadosEdicao } = useContext(PropostaContext)
  const [reloadAtendimento, setReloadAtendimento] = useState(false)

  const salvarTipoAtendimento = async (values) => {
    const payload = {
      idAtendimento: dadosEdicao.idAtendimento,
      idEmpresaNotaFiscal: values?.acEmpresaEmissora?.[0]?.[0],
      vlNota: values?.vlTotal,
    }

    const resp = await metodoPrograma('salvaDivisaoCaucao', payload)
    if (resp.status) {
      setReloadAtendimento((v) => !v)
    }
  }

  const excluiTipoAtendimento = async (values) => {
    // TODO - Verificar se é permitido excluir o item, atualmente só é permitido se o atendimento estiver em aberto, ou seja, dadosEdicao?.tpSituacao === '0'
    const payload = {
      idEmpresaNotaFiscal: values?.[0],
      idAtendimento: values?.[1],
    }

    const resp = await metodoPrograma('excluiDivisaoCaucao', payload)
    if (resp.status) {
      setReloadAtendimento((v) => !v)
    }
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ marginTop: 20 }}>
          <Typography variant="h5">Rateio para Emissão de NFS-e</Typography>
          <Divider />
        </Grid>
        <Grid container spacing={2} style={{ padding: 20 }} item xs={12}>
          <Grid item container spacing={2}>
            {dadosEdicao.idAtendimento && (
              <Grid item xs={12}>
                <PrimeTable
                  action="listaDivisaoCaucao"
                  codigo="CtrlProposta"
                  parametros={{ idAtendimento: dadosEdicao.idAtendimento }}
                  autocompleteEditableIndex={[0]}
                  head={['Empresa', 'Valor', '', '']}
                  refresh={reloadAtendimento}
                  line={(item) => [item?.[2]?.[1], item?.[3], '', '']}
                  collumnsCurrency={[1]}
                  rows={100000}
                  editButton={dadosEdicao.tpSituacao === '0'}
                  addButton={dadosEdicao.tpSituacao === '0'}
                  disablePagination
                  onDelete={
                    dadosEdicao.tpSituacao === '0'
                      ? { index: 3, action: excluiTipoAtendimento }
                      : undefined
                  }
                  fastAddComponent={({ values, edit, close }) => (
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <AutoComplete
                          metodo="buscaEmissorNotaFiscal"
                          value={values?.acEmpresaEmissora}
                          name="acEmpresaEmissora"
                          label="Pacote"
                          fullWidth
                          margin="dense"
                          variant="outlined"
                          size="small"
                          onChange={async (_, val) => {
                            await edit({
                              value: val,
                              field: 'acEmpresaEmissora',
                            })
                            await edit({
                              value: val?.[2] || 0,
                              field: 'vlTotal',
                            })
                          }}
                          textFieldProps={{
                            helperText: !values?.acEmpresaEmissora
                              ? 'Campo Obrigatório!'
                              : '',
                            error: !values?.acEmpresaEmissora,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <CurrencyField
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          name="vlTotal"
                          label="Valor"
                          size="small"
                          value={values?.vlTotal}
                          onChange={(v) => edit({ value: v, field: 'vlTotal' })}
                          helperText={
                            !values?.vlTotal ? 'Campo Obrigatório!' : ''
                          }
                          error={!values?.vlTotal}
                        />
                      </Grid>
                      <Grid
                        item
                        container
                        xs={12}
                        spacing={2}
                        justifyContent="flex-end"
                      >
                        <Grid item xs={12} md={2}>
                          <Button
                            onClick={close}
                            fullWidth
                            variant="contained"
                            color="inherit"
                            style={{ margin: '5px' }}
                          >
                            Cancelar
                          </Button>
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <Button
                            onClick={() =>
                              !!values?.vlTotal &&
                              !!values?.acEmpresaEmissora &&
                              salvarTipoAtendimento(values) &&
                              close()
                            }
                            variant="contained"
                            fullWidth
                            color="primary"
                            style={{ margin: '5px' }}
                          >
                            Salvar
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default DivisaoEmpresaNF
